import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import RenderDiagnostics from "@/components/event/RenderDiagnostics";
import { ArrowLeft, LogOut } from "lucide-react";

export default function Diagnostics() {
  const nav = useNavigate();
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-navy-deep grain">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-navy-deep/80 border-b border-navy-border">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Logo chip height={38} />
          <div className="flex items-center gap-3">
            <span className="hidden sm:block text-sm text-muted-foreground">{user?.email}</span>
            <Button data-testid="logout-button" variant="ghost" size="sm" onClick={logout} className="text-muted-foreground hover:text-ivory">
              <LogOut className="w-4 h-4 mr-1.5" /> Log out
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10 space-y-6">
        <button data-testid="diagnostics-back" onClick={() => nav("/")} className="flex items-center gap-1.5 text-sm text-champagne hover:text-gold">
          <ArrowLeft className="w-4 h-4" /> Back to events
        </button>
        <div>
          <h1 className="font-display text-4xl text-ivory">Render Diagnostics</h1>
          <p className="text-muted-foreground text-sm mt-2">Check the render engine's health and run a small end-to-end test render at any time.</p>
        </div>
        <RenderDiagnostics defaultOpen />
      </main>
    </div>
  );
}
